import { BAG_RPE_ACTION_GATEWAY_BY_INCOMING_CONTAINER } from 'src/app/features/components/bag/bag-rpe.constants';
import { HAWB_RPE_ACTION_GATEWAY } from 'src/app/features/components/hawb/hawb-rpe.constants';

export const ALL_FACILITIES_BLOCKED_ACTION_LABELS = {
  gateway: 'Gatewaying',
  bulkGateway: 'Bulk Gatewaying',
  publish: 'Publishing',
  incomingContainerGateway: 'Gatewaying by Incoming Container',
} as const;

export type AllFacilitiesBlockedActionKey =
  keyof typeof ALL_FACILITIES_BLOCKED_ACTION_LABELS;

export function buildAllFacilitiesFacilityScopedBlockMessage(
  actionLabel: string
): string {
  return `Change your Default location to a single warehouse to proceed with ${actionLabel}`;
}

export const ALL_FACILITIES_GATEWAY_BLOCK_MESSAGE =
  buildAllFacilitiesFacilityScopedBlockMessage(
    ALL_FACILITIES_BLOCKED_ACTION_LABELS.gateway
  );

export const ALL_FACILITIES_BULK_GATEWAY_BLOCK_MESSAGE =
  buildAllFacilitiesFacilityScopedBlockMessage(
    ALL_FACILITIES_BLOCKED_ACTION_LABELS.bulkGateway
  );

export const ALL_FACILITIES_PUBLISH_BLOCK_MESSAGE =
  buildAllFacilitiesFacilityScopedBlockMessage(
    ALL_FACILITIES_BLOCKED_ACTION_LABELS.publish
  );

export const ALL_FACILITIES_INCOMING_CONTAINER_GATEWAY_BLOCK_MESSAGE =
  buildAllFacilitiesFacilityScopedBlockMessage(
    ALL_FACILITIES_BLOCKED_ACTION_LABELS.incomingContainerGateway
  );

const MANIFEST_MODULE_NAMES = new Set(['manifest']);
const MAWB_MODULE_NAMES = new Set(['mawb']);
const SHIPMENT_MODULE_NAMES = new Set(['shipment', 'hawb']);

function normalizeModuleName(moduleName: string): string {
  return moduleName.trim().toLowerCase();
}

function normalizeActionName(actionName: string): string {
  return actionName.trim().toLowerCase();
}

export function isFacilityScopedActionBlockedForAllFacilitiesDefault(
  moduleName: string,
  actionName: string
): boolean {
  const module = normalizeModuleName(moduleName);
  const action = normalizeActionName(actionName);

  if (
    SHIPMENT_MODULE_NAMES.has(module) &&
    (action === HAWB_RPE_ACTION_GATEWAY ||
      action === 'bulk gateway' ||
      action === 'gateway')
  ) {
    return true;
  }

  if (
    (MANIFEST_MODULE_NAMES.has(module) || MAWB_MODULE_NAMES.has(module)) &&
    action === 'publish'
  ) {
    return true;
  }

  if (
    module === 'bag' &&
    action === normalizeActionName(BAG_RPE_ACTION_GATEWAY_BY_INCOMING_CONTAINER)
  ) {
    return true;
  }

  return false;
}

export function getAllFacilitiesBlockedActionMessage(
  moduleName: string,
  actionName: string
): string | undefined {
  const module = normalizeModuleName(moduleName);
  const action = normalizeActionName(actionName);

  if (
    SHIPMENT_MODULE_NAMES.has(module) &&
    action === 'bulk gateway'
  ) {
    return ALL_FACILITIES_BULK_GATEWAY_BLOCK_MESSAGE;
  }

  if (
    SHIPMENT_MODULE_NAMES.has(module) &&
    (action === HAWB_RPE_ACTION_GATEWAY || action === 'gateway')
  ) {
    return ALL_FACILITIES_GATEWAY_BLOCK_MESSAGE;
  }

  if (
    (MANIFEST_MODULE_NAMES.has(module) || MAWB_MODULE_NAMES.has(module)) &&
    action === 'publish'
  ) {
    return ALL_FACILITIES_PUBLISH_BLOCK_MESSAGE;
  }

  if (
    module === 'bag' &&
    action === normalizeActionName(BAG_RPE_ACTION_GATEWAY_BY_INCOMING_CONTAINER)
  ) {
    return ALL_FACILITIES_INCOMING_CONTAINER_GATEWAY_BLOCK_MESSAGE;
  }

  return undefined;
}
